import React from 'react';
import { EntityTaskDetails } from 'components/common/tasks/entityTaskDetails';
import { useParams } from 'react-router-dom';
import { usePurchaseOrderByIdQuery } from 'api';

export const PurchaseOrderTaskDetails = () => {
  const { id } = useParams() as { id: string };
  const { data: { purchaseOrder = {} } = {} } = usePurchaseOrderByIdQuery({ id }, { skip: !id });
  return <EntityTaskDetails entityName={'PURCHASE_ORDER'} isFinalStatus={purchaseOrder.isFinalStatus} />;
};
